import { Guid, IDictionary, isNullOrEmpty } from "@ioip/core/lib";
import { FormNotFoundException } from "../../exceptions";
import { IJSPage } from "../../types/IJSPage";
import { IFieldValue } from "./IFieldValue";
import { JSDataSource } from "./JSDataSource";
import { JSDataSourceCollection } from "./JSDataSourceCollection";
import { JSEngine } from "./JSEngine";
import { CForm } from "./JSForm";

export interface IJSFormProps {
    schema: IJSPage;
    engine: JSEngine;
    values?: IDictionary<any>;
}

export class JSPage {

    $props: IJSFormProps;
    $entryPoint: Guid;
    $isLoading: boolean = false;
    $dataSourceCollection: JSDataSourceCollection = null;

    constructor(props: IJSFormProps) {
        this.$props = props;
        this.$dataSourceCollection = new JSDataSourceCollection(props.schema.dataSources || []);
        this.$entryPoint = Guid.parse(this.$props.schema.entryPoint);
    }

    async loadEntryPointV1Async(itemId?: string | number): Promise<CForm> {
        let values: IDictionary<any>;
        if (itemId != null && ((typeof itemId == 'number' && itemId > 0) || (typeof itemId === 'string' && !isNullOrEmpty(itemId))))
            values = await this.$props.engine.getPageDataV1Async(this.$entryPoint, itemId);
        const form = this.getForm(this.$entryPoint, itemId, values || {});
        return form;
    }

    async loadEntryPointV2Async(itemId?: string | number): Promise<CForm> {
        let values: IDictionary<IFieldValue>;
        if (itemId != null && ((typeof itemId == 'number' && itemId > 0) || (typeof itemId === 'string' && !isNullOrEmpty(itemId))))
            values = await this.$props.engine.getPageDataV2Async(this.$entryPoint, itemId);
        const form = this.getForm(this.$entryPoint, itemId, values || {});
        return form;
    }

    getDataSources(entityId: Guid): JSDataSource {
        return this.$dataSourceCollection.getDataSources(entityId);
    }

    get isLoading(): boolean {
        return this.$isLoading || false;
    }

    getForm(objectId: Guid, itemId: string | number, values: IDictionary<IFieldValue>): CForm {

        // Verificar que el ID del formulario a cargar sea válido
        if (objectId instanceof Guid == false)
            throw new Error('formVersionId must be a Guid');

        // Obtener el schema del formulario
        const id = objectId.toString();
        const forms = this.$props.schema.forms || [];
        const form = forms.find(x => x.formId == id);
        if (form == null)
            return null;

        // Crear instancia del formulario
        const result = new CForm({
            object: {
                objectId: form.formId,
                code: form.code,
                name: form.name,
                schema: form,
                enabled: true,
            },
            engine: this.$props.engine,
            page: this,
            isRuntime: true,
            itemId
        });

        // Establecer valores iniciales
        result.values = values;

        return result;
    }

    async initialize(): Promise<void> {

    }

}